import styled from 'styled-components';
import { Row, Text, Title as DefaultTitle } from '~components';

export const Container = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const RadioGroup = styled(Row)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.km10};
  & > div {
    display: flex;
    flex: 1;
  }
`;

export const Description = styled(Text)`
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km3};

  :last-of-type {
    margin-right: ${({ theme }) => theme.spacing.km2};
  }
`;

export const Option = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    margin-right: ${({ theme }) => theme.spacing.km3};
  }
`;

export const Title = styled(DefaultTitle)`
  margin-top: ${({ theme }) => theme.spacing.km10};
`;
